import api from './api';
import { TicketCategory, TicketStatus, SupportTicket, SupportTicketDetail } from '../types/support';

export const supportService = {
  async createTicket(data: {
    subject: string;
    category: TicketCategory;
    message: string;
  }): Promise<SupportTicketDetail> {
    const res = await api.post('/support/', data);
    return res.data;
  },

  async listMyTickets(): Promise<SupportTicket[]> {
    const res = await api.get('/support/');
    return res.data;
  },

  async getTicket(ticketId: string): Promise<SupportTicketDetail> {
    const res = await api.get(`/support/${ticketId}`);
    return res.data;
  },

  async replyToTicket(ticketId: string, content: string): Promise<void> {
    await api.post(`/support/${ticketId}/messages`, { content });
  },

  // Admin
  async adminListTickets(statusFilter?: TicketStatus): Promise<SupportTicket[]> {
    const params = statusFilter ? { status: statusFilter } : {};
    const res = await api.get('/support/admin/all', { params });
    return res.data;
  },

  async adminGetTicket(ticketId: string): Promise<SupportTicketDetail> {
    const res = await api.get(`/support/${ticketId}`);
    return res.data;
  },

  async adminUpdateStatus(ticketId: string, status: TicketStatus): Promise<void> {
    await api.patch(`/support/admin/${ticketId}/status`, { status });
  },

  async adminReply(ticketId: string, content: string): Promise<void> {
    await api.post(`/support/${ticketId}/messages`, { content });
  },
};
